import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

type Copyright = {
  text: string;
};

export function Copyright({ text }: Copyright) {
  const { t } = useSonTranslation('glossary');

  if (!text) {
    return null;
  }
  return (
    <p className="media-information__copyright">
      <dfn className="invisible">{`${t(`copyright`)}:`}</dfn>
      <span aria-hidden="true">©</span> {text}
    </p>
  );
}
